module.exports = __webpack_public_path__ + "static/media/character-2.041f3550.gif";